import React, { useState, useEffect } from "react";
import style from "./ConfirmUssd.module.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/modal";

const ConfirmUssdOrder = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [price, setPrice] = useState(1);
  const location = useLocation();
  const receivedData = location.state?.data || "No data received.";

  const endpoint = receivedData?.product_type;

  const [selectedProduct, setSelectedProduct] = useState("");
  const [listItem, setItem] = useState([]);
  const handleProductChange = (event) => {
    setSelectedProduct(event.target.value);
  };
  useEffect(() => {
    const fetch = async () => {
      const response = await axios.get(
        `https://plus.lifebank.ng/lite/v2/api/admin/product/ussd/items/${endpoint}`
      );
      setItem(response?.data?.data);
    };
    fetch();
  }, []);

  const data = {
    ussd_id: receivedData?.id,
    product: selectedProduct,
    qty: quantity,
    price: price,
  };

  const handlePlaceorder = async () => {
    const response = await axios.post(
      `https://plus.lifebank.ng/lite/v2/api/admin/product/ussd/placeorder`,
      data
    );
    setShowModal(true);
    // alert(`You have successfully placed an order`);
    // navigate(`/ussd-product`);
  };

  return (
    <div className={style.body}>
      {showModal && <Modal setShowModal={setShowModal}/>}
      <h2 className={style.title}>Confirm Ussd Order</h2>
      <div className={style.container}>
        <h3>Select Product</h3>
        <select value={selectedProduct} onChange={handleProductChange}>
          <option value="">Select a product</option>
          {listItem?.map((product) => (
            <option key={product.id} value={product.name}>
              {product.name}
            </option>
          ))}
        </select>
        <h3 className={style.quantity}>Quantity</h3>
        <input
          type="number"
          value={quantity}
          onChange={(event) => setQuantity(event.target.value)}
        />
        <h3 className={style.quantity}>Price</h3>
        <input
          type="number"
          value={price}
          onChange={(event) => setPrice(event.target.value)}
        />

        <div className={style.centeredButtonContainer}>
          <div className={style.button} onClick={handlePlaceorder}>
            <p className={style.buttonText}>Proceed to place-order</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmUssdOrder;
